import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAttrs } from "vue";
// const databaseFormat = "YYYY-MM-DD";

// export default {
//   inheritAttrs: false,
// };

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "VZDropMessage",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const attrs = useAttrs();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _normalizeProps(_guardReactiveProps(_unref(attrs))), "Please drop control", 16))
}
}

})